module.exports = __webpack_public_path__ + "static/media/Measure.44d9531b.svg";